/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { FulfillmentServiceData, FulfillmentServiceType } from '@/models';

import { id } from './id';

const InStorePickup: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.InStorePickup,
  name: '實體店面取貨',
  description: '',
};

const SevenEleven: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.SevenEleven,
  name: '7-11 超商取貨',
  description: '平均到貨天數 2-3 天',
};

const Ecan: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.Ecan,
  name: '台灣宅配通',
  description: '平均到貨天數 2-3 天',
};

const MajorApplianceDelivery: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.MajorApplianceDelivery,
  name: '大型電器原廠配送',
  description: '$500/以件計費，含基本運送及安裝',
};

const KitchenApplianceDelivery: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.KitchenApplianceDelivery,
  name: '三機原廠配送',
  description: '$1000/以件計費，含基本運送 + 安裝',
};

const WestinghouseTVDelivery: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.WestinghouseTVDelivery,
  name: '西屋電視原廠配送',
  description: '$1000/以件計費，含安裝',
};

const FruitDirectShipping: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.FruitDirectShipping,
  name: '農產水果產地直送',
  description: '',
};

const TravelToBuyDelivery: FulfillmentServiceData = {
  id: id(),
  handle: FulfillmentServiceType.TravelToBuyDelivery,
  name: '飛買家旅遊超市',
  description: '',
};

export default {
  InStorePickup,
  SevenEleven,
  Ecan,
  MajorApplianceDelivery,
  KitchenApplianceDelivery,
  WestinghouseTVDelivery,
  FruitDirectShipping,
  TravelToBuyDelivery,
};
